import { CommonResponse, returnException } from "@boi/backend-utils";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AiGeneratedQpService } from "./ai-generated-qp.service";
import { ClassRequestModel, ClassNameRequestModel, SubjectClassReqModel, ChapterReqModel, ClassSubjectReq, QuestionReqModel, CreateQuestionPaperReq, QnosReq, QNPIdReq, ClonePaperReq, qPRequestModel, ClassSubjectReqModel, ClassIdRequestModel, DefaultModelPaperCheckReqModel, QPaperMergeGerReqModel, QPaperMergeCreateReqModel } from "@boi/shared-models";

@ApiTags('AIGeneratedQp')
@Controller('ai_generated_qp')
export class AIGeneratedQPController {
    constructor(private readonly aiGeneratedQPService: AiGeneratedQpService) { }

    @Post('getAllClasses')
    async getAllClasses(): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllClasses();
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }


    @Post('getLanguagesByClassSubject')
    async getLanguagesByClassSubject(@Body() req: ClassSubjectReq) {
        try {
            return await this.aiGeneratedQPService.getLanguagesByClassSubject(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllLanguages')
    async getAllLanguages() {
        try {
            return await this.aiGeneratedQPService.getAllLanguages();
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getSubjectsByClass')
    async getSubjectsByClass(@Body() req: ClassRequestModel) {
        try {
            return await this.aiGeneratedQPService.getSubjectsByClass(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getBaseSubjectsDropDown')
    async getBaseSubjectsDropDown(@Body() req: ClassRequestModel) {
        try {
            return await this.aiGeneratedQPService.getBaseSubjectsDropDown(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getChaptersBySubject')
    async getChaptersBySubject(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getChaptersBySubject(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getDistinctSubjects')
    async getDistinctSubjects(@Body() req: ClassNameRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getDistinctSubjects(req.className);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getSubjectByClass')
    async getSubjectByClass(@Body() req: ClassIdRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getSubjectByClass(req.classId);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getDistinctChapters')
    async getDistinctChapters(@Body() req: ClassNameRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getDistinctChapters(req.className);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getChaptersBySubjectAndClass')
    async getChaptersBySubjectAndClass(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getChaptersBySubjectAndClass(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getDistinctMarks')
    async getDistinctMarks(@Body() req: ClassNameRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getDistinctMarks(req.className);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getDistinctMarksFromCreateQuestions')
    async getDistinctMarksFromCreateQuestions(@Body() req: ChapterReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getDistinctMarksFromCreateQuestions(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getMarksByClass')
    async getMarksByClass(@Body() req: ClassIdRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getMarksByClass(req.classId);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getChaptersByClassAndSubject')
    async getChaptersByClassAndSubject(@Body() req: ClassSubjectReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getChaptersByClassAndSubject(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getTopicsByChapter')
    async getTopicsByChapter(@Body() req: ChapterReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getTopicsByChapter(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getMarksByChapter')
    async getMarksByChapter(@Body() req: ChapterReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getMarksByChapter(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllDifficultyLevels')
    async getAllDifficultyLevels(): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllDifficultyLevels();
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestionTypes')
    async getAllQuestionTypes(): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestionTypes();
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestions')
    async getAllQuestions(@Body() req: QuestionReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestions(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestionsCount')
    async getAllQuestionsCount(@Body() req: QuestionReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestionsCount(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('createQuestionPaper')
    async createQuestionPaper(@Body() req: CreateQuestionPaperReq): Promise<CommonResponse> {

        try {
            return await this.aiGeneratedQPService.createQuestionPaper(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestionPapers')
    async getAllQuestionPapers(@Body() req: qPRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestionPapers(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }


    @Post('getAllQuestionPapersToMerge')
    async getAllQuestionPapersToMerge(@Body() req: QPaperMergeGerReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestionPapersToMerge(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestionsByIds')
    async getAllQuestionsByIds(@Body() req: QnosReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllQuestionsByIds(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getQuestionPaperDataById')
    async getQuestionPaperDataById(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getQuestionPaperDataById(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('generateOtp')
    async generateOtp(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.generateOtp(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('validateOtp')
    async validateOtp(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.validateOtp(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('clonePaperToOtherLanguage')
    async clonePaperToOtherLanguage(@Body() req: ClonePaperReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.clonePaperToOtherLanguage(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('isDefaultModelPaperExist')
    async isDefaultModelPaperExist(@Body() req: DefaultModelPaperCheckReqModel) {
        try {
            return await this.aiGeneratedQPService.isDefaultModelPaperExist(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getSubjectsByClassId')
    async getSubjectsByClassId(@Body() req: ClassRequestModel) {
        try {
            return await this.aiGeneratedQPService.getSubjectsByClassId(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getOtherLanguageSubjects')
    async getOtherLanguageSubjects(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getOtherLanguageSubjects(req);
        } catch (error) {
            return returnException(CommonResponse, error);

        }
    }

    @Post('getAllSubjectIdsForPreview')
    async getAllSubjectIdsForPreview(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllSubjectIdsForPreview(req);
        } catch (error) {
            return returnException(CommonResponse, error);

        }
    }

    @Post('getOtherLanguageQuestions')
    async getOtherLanguageQuestions(@Body() req: CreateQuestionPaperReq): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getOtherLanguageQuestions(req);
        } catch (error) {
            return returnException(CommonResponse, error);

        }
    }


    @Post('savePaperMergeData')
    async savePaperMergeData(@Body() req: QPaperMergeCreateReqModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.savePaperMergeData(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }


    @Post('getAllPaperMergeData')
    async getAllPaperMergeData(@Body() req: ClassIdRequestModel): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getAllPaperMergeData(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }
   
    @Post('getDistinctSubjectsForLogin')
    async getDistinctSubjectsForLogin(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.aiGeneratedQPService.getDistinctSubjectsForLogin();
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }
}